var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-main-header"},[_c('div',{staticClass:"header"},[_c('h1',{staticClass:"head1 colored"},[_vm._v(_vm._s(_vm.symbol))])]),_vm._v(" "),_c('p',{staticClass:"card-main-name"},[_vm._v(_vm._s(_vm.companyName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a45182e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/CompanyHeader.vue
// module id = null
// module chunks = 